
import { Controller } from '../common/Controller';
import { Helper } from '../common/helpers/Helper';
import { AppConfig } from '../AppConfig';
import { StyleSheet, css } from 'aphrodite';
import Icon from '@material-ui/core/Icon';
import React from 'react';
import moment from 'moment';
import { UiHelper } from '../common/helpers/UiHelper';
import { Tooltip } from '@material-ui/core';
import { AppUiHelper } from './AppUiHelper';

const vsprintf = require('sprintf-js').vsprintf

export class AppHelper {
  static DAY_MS = 24 * 3600 * 1000
  static getMimeTypeFromUrl = (url = '') => {
    const cleanUrl = String(url || '').toLowerCase().split(/[?#]/)[0]
    const extensionToMimeType = {
      mp4: 'video/mp4',
      webm: 'video/webm',
      mov: 'video/quicktime',
      m4v: 'video/x-m4v',
      avi: 'video/x-msvideo',
      png: 'image/png',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      gif: 'image/gif',
      webp: 'image/webp',
      svg: 'image/svg+xml',
      bmp: 'image/bmp'
    }
    const matchedExtension = Object.keys(extensionToMimeType).find((extension) => cleanUrl.endsWith(`.${extension}`))
    return matchedExtension ? extensionToMimeType[matchedExtension] : ''
  }

  static getDrawerMenuItems(org) {
    return AppHelper.isDrawerMenuEnabled(org)
  }

  static changeFieldOptionLabel = (formDefinition, options) => {
    console.log('formDefinition', formDefinition)
    if (formDefinition && formDefinition.steps[0] && formDefinition.steps[0].fields) {
      formDefinition.steps[0].fields.map((x) => {
        if (x.key === options.fieldKey) {
          x.options.map((y) => {
            if (y.key === options.keyToReplace) {
              y.label = options.replaceWithValue
            }
            return y
          })
        }
        return x
      })
    }
    return formDefinition
  }

  static _insertMoreElement(arr, element) {
    if (arr.length >= 4) {
      arr.splice(3, 0, element); // Insert at index 3
    } else {
      arr.push(element); // Insert at the end
    }
    return arr;
  }

  static _filterSidebarMenu(sidebarMenu, isSu = false) {
    const menuGroups = Array.isArray(sidebarMenu[0]) ? sidebarMenu : [sidebarMenu]

    return menuGroups
      .map(group => group.map(menuItem => {
        if (menuItem.subItems) {
          const subItems = menuItem.subItems.filter(subItem =>
            AppHelper.isAccessAllowed(subItem.key, isSu)
          )

          return subItems.length > 0
            ? {
              ...menuItem,
              subItems
            }
            : null
        }

        return AppHelper.isAccessAllowed(menuItem.key, isSu) ? menuItem : null
      }).filter(Boolean))
      .filter(group => group.length > 0)
  }

  static getAdminDrawerMenuItems(role) {
    let sidebarMenu = []
    if (this.isMobileview()) {
      sidebarMenu =
        [
          {
            route: vsprintf('/admin/'),
            title: Helper.getString('orgs'),
            icon: 'business',
            key: 'Orgs'
          },
          {
            route: vsprintf('/admin/screens/'),
            title: 'Screens',
            icon: 'storefront',
            key: 'Venues',
            image: require('../assets/icons/venues.svg')
          },
          {
            route: vsprintf('/admin/reports/'),
            title: Helper.getString('reports'),
            icon: 'insights',
            key: 'AdPopReport'
          },
          {
            route: vsprintf('/admin/dps-activity/'),
            title: Helper.getString('exchangeReports'),
            icon: 'insights',
            key: 'DpsActivity'
          },
          {
            route: vsprintf('/admin/screen-fill-rate'),
            title: 'Fill Rate',
            icon: 'stacked_bar_chart',
            key: 'ScreenPerformanceDashboard'
          },
          {
            route: vsprintf('/admin/screen-health-summary/'),
            title: 'Health',
            icon: 'monitor_heart',
            key: 'ScreenHealthSummary'
          },
          // {
          //   route: vsprintf('/admin/venuegroups/'),
          //   title: 'Screen Groups',
          //   icon: 'group_work',
          //   key: 'VenueGroups',
          // },
          {
            route: vsprintf('/admin/campaigns/'),
            title: Helper.getString('campaigns'),
            icon: 'connected_tv',
            key: 'CampaignsDisplay',
            image: require('../assets/icons/campaigns.svg')
          },
          {
            key: 'AssetsItems',
            route: vsprintf('/admin/assets'),
            title: Helper.getString('media'),
            icon: 'perm_media',
            image: require('../assets/icons/media.svg')
          },
          {
            key: 'TagsDisplay',
            route: vsprintf('/admin/tags'),
            title: Helper.getString('tags'),
            image: require('../assets/icons/tags.svg')
          },
          {
            key: 'MediaTagsDisplay',
            route: vsprintf('/admin/media-tags'),
            title: Helper.getString('mediaTags'),
            icon: 'label',
            // image: require('../assets/icons/tags.svg')
          },
          {
            key: 'BrandNamesDisplay',
            route: vsprintf('/admin/brand-names'),
            title: Helper.getString('brandNames'),
            image: require('../assets/icons/tags.svg')
          },
          {
            key: 'LayoutsItems',
            route: vsprintf('/admin/layouts'),
            title: Helper.getString('layouts'),
            icon: 'view_quilt',
          },
          {
            route: vsprintf('/admin/audio-ads/'),
            title: Helper.getString('audio-ads'),
            icon: 'graphic_eq',
            key: 'CampaignsAudioBO',
            image: require('../assets/icons/audio-ads.svg')
          },
          {
            route: vsprintf('/admin/jobs/'),
            title: Helper.getString('jobs'),
            // icon: 'loop',
            key: 'Jobs'
          },
          // {
          //   route: vsprintf('/admin/venue-explorer/'),
          //   title: Helper.getString('venueExplorer'),
          //   // icon: 'people',
          //   key: 'VenueExplorer',
          //   // image:require('../assets/icons/venues.svg')
          // },
          // {
          //   route: vsprintf('/admin/settings-master/'),
          //   title: Helper.getString('settingsMaster'),
          //   // icon: 'settings',
          //   key: 'settingsMaster',
          //   // image:require('../assets/icons/settings.svg')
          // },
          {
            route: vsprintf('/admin/users/'),
            title: Helper.getString('productadmins'),
            // icon: 'people',
            key: 'UsersOfOrg',
            // image:require('../assets/icons/users.svg')
          },
          {
            route: vsprintf('/admin/tasks/'),
            title: Helper.getString('tasks'),
            // icon: 'loop',
            key: 'Tasks'
          }
        ]
      // const insertIndex = (role.includes('SUPERUSER')) ? 3 : 7;
      // sidebarMenu = [
      //   ...sidebarMenu.slice(0, insertIndex),
      //   moreMenu,
      //   ...sidebarMenu.slice(insertIndex),
      // ]
    } else {
      sidebarMenu = [
        {
          route: vsprintf('/admin/'),
          title: Helper.getString('orgs'),
          icon: 'business',
          key: 'Orgs'
        },
        {
          route: vsprintf('/admin/screens/'),
          title: 'Screens',
          icon: 'storefront',
          key: 'Venues',
          image: require('../assets/icons/venues.svg')
        },
        {
          title: Helper.getString('content'),
          image: require('../assets/icons/media.svg'),
          subItems: [
            {
              route: vsprintf('/admin/campaigns/'),
              title: Helper.getString('campaigns'),
              icon: 'connected_tv',
              key: 'CampaignsDisplay',
              image: require('../assets/icons/campaigns.svg')
            }, {
              key: 'AssetsItems',
              route: vsprintf('/admin/assets'),
              title: Helper.getString('media'),
              icon: 'perm_media',
              image: require('../assets/icons/media.svg')
            },
            {
              key: 'LayoutsItems',
              route: vsprintf('/admin/layouts'),
              title: Helper.getString('layouts'),
              icon: 'view_quilt',
            },
            {
              route: vsprintf('/admin/exchange-creatives/'),
              title: Helper.getString('approvals'),
              icon: 'ads_click',
              key: 'DdSearch',
            },
            {
              route: vsprintf('/admin/audio-ads/'),
              title: Helper.getString('audio-ads'),
              icon: 'graphic_eq',
              key: 'CampaignsAudioBO',
              image: require('../assets/icons/audio-ads.svg')
            }
          ]
        },
        {
          key: 'reports',
          icon: 'assessment',
          title: Helper.getString('reportsTitle'),
          subItems: [
            {
              route: vsprintf('/admin/reports/'),
              title: Helper.getString('reports'),
              icon: 'loop',
              key: 'AdPopReport'
            },
            {
              route: vsprintf('/admin/dps-activity/'),
              title: Helper.getString('exReports'),
              icon: 'insights',
              key: 'DpsActivity'
            },
            {
              route: vsprintf('/admin/screen-fill-rate'),
              title: 'Fill Rate',
              icon: 'stacked_bar_chart',
              key: 'ScreenPerformanceDashboard'
            },
            {
              route: vsprintf('/admin/screen-health-summary/'),
              title: 'Health',
              icon: 'monitor_heart',
              key: 'ScreenHealthSummary'
            },
          ]
        },
        {
          route: vsprintf('/admin/jobs/'),
          title: Helper.getString('jobs'),
          // icon: 'loop',
          key: 'Jobs'
        },
        {
          route: vsprintf('/admin/tasks/'),
          title: Helper.getString('tasks'),
          // icon: 'loop',
          key: 'Tasks'
        },
        {
          route: vsprintf('/admin/venue-explorer/'),
          title: Helper.getString('venueExplorer'),
          // icon: 'people',
          key: 'VenueExplorer',
          // image:require('../assets/icons/venues.svg')
        },
        {
          key: 'settings',
          // icon: 'management',
          title: Helper.getString('settings'),
          subItems: [
            {
              route: vsprintf('/admin/users/'),
              title: Helper.getString('productadmins'),
              // icon: 'people',
              key: 'UsersOfOrg',
              // image:require('../assets/icons/users.svg')
            },
            {
              key: 'BrandNamesDisplay',
              route: vsprintf('/admin/brand-names'),
              title: Helper.getString('brandNames'),
              // image: require('../assets/icons/tags.svg')
            },
            {
              key: 'RestrictionTagsDisplay',
              route: vsprintf('/admin/restriction-tags'),
              title: Helper.getString('restrictionTags'),
              // icon: 'label',
              // image: require('../assets/icons/tags.svg')
            },
            {
              key: 'TagsDisplay',
              route: vsprintf('/admin/tags'),
              title: Helper.getString('tags'),
              // image: require('../assets/icons/tags.svg')
            },
            {
              key: 'MediaTagsDisplay',
              route: vsprintf('/admin/media-tags'),
              title: Helper.getString('mediaTags'),
              // icon: 'label',
              // image: require('../assets/icons/tags.svg')
            },

            {
              route: vsprintf('/admin/settings-master/'),
              title: Helper.getString('settingsMaster'),
              // icon: 'settings',
              key: 'settingsMaster',
              // image:require('../assets/icons/settings.svg')
            },
          ]
        },
      ]
    }
    const filteredMenu = AppHelper._filterSidebarMenu(sidebarMenu, true)
    if (this.isMobileview()) {
      const moreMenu = {
        key: 'more',
        title: Helper.getString('menu'),
      }
      if (filteredMenu[0]) AppHelper._insertMoreElement(filteredMenu[0], moreMenu)
    }
    return filteredMenu
  }

  static getAdminDrawerMenuItemsOld(role) {
    let sidebarMenu = []
    if (this.isMobileview()) {
      sidebarMenu =
        [
          {
            route: vsprintf('/admin/'),
            title: Helper.getString('orgs'),
            icon: 'business',
            key: 'Orgs'
          },
          {
            route: vsprintf('/admin/screens/'),
            title: 'Screens',
            icon: 'storefront',
            key: 'Venues',
            image: require('../assets/icons/venues.svg')
          },
          {
            route: vsprintf('/admin/reports/'),
            title: Helper.getString('reports'),
            icon: 'insights',
            key: 'AdPopReport'
          },
          {
            route: vsprintf('/admin/dps-activity/'),
            title: Helper.getString('exchangeReports'),
            icon: 'insights',
            key: 'DpsActivity'
          },
          {
            route: vsprintf('/admin/screen-fill-rate'),
            title: 'Fill Rate',
            icon: 'stacked_bar_chart',
            key: 'ScreenPerformanceDashboard'
          },
          {
            route: vsprintf('/admin/screen-health-summary/'),
            title: 'Health',
            icon: 'monitor_heart',
            key: 'ScreenHealthSummary'
          },
          // {
          //   route: vsprintf('/admin/venuegroups/'),
          //   title: 'Screen Groups',
          //   icon: 'group_work',
          //   key: 'VenueGroups',
          // },
          {
            route: vsprintf('/admin/campaigns/'),
            title: Helper.getString('campaigns'),
            icon: 'connected_tv',
            key: 'CampaignsDisplay',
            image: require('../assets/icons/campaigns.svg')
          },
          {
            key: 'AssetsItems',
            route: vsprintf('/admin/assets'),
            title: Helper.getString('media'),
            icon: 'perm_media',
            image: require('../assets/icons/media.svg')
          },
          {
            key: 'LayoutsItems',
            route: vsprintf('/admin/layouts'),
            title: Helper.getString('layouts'),
            icon: 'view_quilt',
          },
          {
            route: vsprintf('/admin/audio-ads/'),
            title: Helper.getString('audio-ads'),
            icon: 'graphic_eq',
            key: 'CampaignsAudioBO',
            image: require('../assets/icons/audio-ads.svg')
          },
          {
            route: vsprintf('/admin/jobs/'),
            title: Helper.getString('jobs'),
            // icon: 'loop',
            key: 'Jobs'
          },
          // {
          //   route: vsprintf('/admin/venue-explorer/'),
          //   title: Helper.getString('venueExplorer'),
          //   // icon: 'people',
          //   key: 'VenueExplorer',
          //   // image:require('../assets/icons/venues.svg')
          // },
          // {
          //   route: vsprintf('/admin/settings-master/'),
          //   title: Helper.getString('settingsMaster'),
          //   // icon: 'settings',
          //   key: 'settingsMaster',
          //   // image:require('../assets/icons/settings.svg')
          // },
          {
            route: vsprintf('/admin/users/'),
            title: Helper.getString('productadmins'),
            // icon: 'people',
            key: 'UsersOfOrg',
            // image:require('../assets/icons/users.svg')
          },
          {
            route: vsprintf('/admin/tasks/'),
            title: Helper.getString('tasks'),
            // icon: 'loop',
            key: 'Tasks'
          }
        ]
      // const insertIndex = (role.includes('SUPERUSER')) ? 3 : 7;
      // sidebarMenu = [
      //   ...sidebarMenu.slice(0, insertIndex),
      //   moreMenu,
      //   ...sidebarMenu.slice(insertIndex),
      // ]
    } else {
      sidebarMenu = [
        {
          route: vsprintf('/admin/'),
          title: Helper.getString('orgs'),
          icon: 'business',
          key: 'Orgs'
        },
        {
          route: vsprintf('/admin/screens/'),
          title: 'Screens',
          icon: 'storefront',
          key: 'Venues',
          image: require('../assets/icons/venues.svg')
        },
        // {
        //   route: vsprintf('/admin/venuegroups/'),
        //   title: 'Screen Groups',
        //   icon: 'group_work',
        //   key: 'VenueGroups',
        // },
        {
          route: vsprintf('/admin/campaigns/'),
          title: Helper.getString('campaigns'),
          icon: 'connected_tv',
          key: 'CampaignsDisplay',
          image: require('../assets/icons/campaigns.svg')
        },
        {
          key: 'AssetsItems',
          route: vsprintf('/admin/assets'),
          title: Helper.getString('media'),
          icon: 'perm_media',
          image: require('../assets/icons/media.svg')
        },
        {
          key: 'TagsDisplay',
          route: vsprintf('/admin/tags'),
          title: Helper.getString('tags'),
          image: require('../assets/icons/tags.svg')
        },
        {
          key: 'MediaTagsDisplay',
          route: vsprintf('/admin/media-tags'),
          title: Helper.getString('mediaTags'),
          icon: 'label',
          // image: require('../assets/icons/tags.svg')
        },
        {
          key: 'BrandNamesDisplay',
          route: vsprintf('/admin/brand-names'),
          title: Helper.getString('brandNames'),
          image: require('../assets/icons/tags.svg')
        },
        {
          key: 'LayoutsItems',
          route: vsprintf('/admin/layouts'),
          title: Helper.getString('layouts'),
          icon: 'view_quilt',
        },
        {
          route: vsprintf('/admin/audio-ads/'),
          title: Helper.getString('audio-ads'),
          icon: 'graphic_eq',
          key: 'CampaignsAudioBO',
          image: require('../assets/icons/audio-ads.svg')
        },
        {
          route: vsprintf('/admin/reports/'),
          title: Helper.getString('reports'),
          // icon: 'loop',
          key: 'AdPopReport'
        },
        {
          route: vsprintf('/admin/dps-activity/'),
          title: Helper.getString('exchangeReports'),
          // icon: 'insights',
          key: 'DpsActivity'
        },
        {
          route: vsprintf('/admin/screen-fill-rate'),
          title: 'Fill Rate',
          key: 'ScreenPerformanceDashboard'
        },
        {
          route: vsprintf('/admin/screen-health-summary/'),
          title: 'Health',
          key: 'ScreenHealthSummary'
        },
        {
          route: vsprintf('/admin/jobs/'),
          title: Helper.getString('jobs'),
          // icon: 'loop',
          key: 'Jobs'
        },
        {
          route: vsprintf('/admin/venue-explorer/'),
          title: Helper.getString('venueExplorer'),
          // icon: 'people',
          key: 'VenueExplorer',
          // image:require('../assets/icons/venues.svg')
        },
        {
          route: vsprintf('/admin/settings-master/'),
          title: Helper.getString('settingsMaster'),
          // icon: 'settings',
          key: 'settingsMaster',
          // image:require('../assets/icons/settings.svg')
        },
        {
          route: vsprintf('/admin/users/'),
          title: Helper.getString('productadmins'),
          // icon: 'people',
          key: 'UsersOfOrg',
          // image:require('../assets/icons/users.svg')
        },
        {
          route: vsprintf('/admin/tasks/'),
          title: Helper.getString('tasks'),
          // icon: 'loop',
          key: 'Tasks'
        }
      ]
    }
    const filteredMenu = sidebarMenu.filter(menuItem => AppHelper.isAccessAllowed(menuItem.key, true));
    if (this.isMobileview()) {
      const moreMenu = {
        key: 'more',
        title: Helper.getString('menu'),
      }
      AppHelper._insertMoreElement(filteredMenu, moreMenu)
    }
    return [filteredMenu]
  }

  static getSiteUserDrawerMenuItems(orgId) {
    const path = Controller.get().roleHelper().getPathByOrgType('SITE')
    if (this.isMobileview()) {
      return [
        [{
          route: vsprintf('/admin/%s/%s/screens', [path, orgId]),
          title: Helper.getString('venues'),
          icon: 'storefront',
          key: 'Venues',
          image: require('../assets/icons/venues.svg')
        },
        {
          key: 'Revenue',
          route: vsprintf('/admin/%s/%s/revenue', [path, orgId]),
          title: Helper.getString('revenue'),
          icon: 'monetization_on',
          image: require('../assets/icons/reports.svg')
        },
        {
          key: 'DisplayAds',
          route: vsprintf('/admin/%s/%s/display-ads', [path, orgId]),
          title: Helper.getString('display-ads'),
          icon: 'connected_tv',
          image: require('../assets/icons/campaigns.svg')
        },
        {
          key: 'more',
          title: Helper.getString('menu'),
        },
        {
          key: 'AudioAds',
          route: vsprintf('/admin/%s/%s/audio-ads', [path, orgId]),
          title: Helper.getString('audio-ads'),
          icon: 'graphic_eq',
          image: require('../assets/icons/audio-ads.svg')
        },
        ]
      ]
    } else {
      return [
        [
          {
            route: vsprintf('/admin/%s/%s/screens', [path, orgId]),
            title: Helper.getString('venues'),
            icon: 'storefront',
            key: 'Venues',
            image: require('../assets/icons/venues.svg')
          },
          {
            key: 'DisplayAds',
            route: vsprintf('/admin/%s/%s/display-ads', [path, orgId]),
            title: Helper.getString('display-ads'),
            icon: 'connected_tv',
            image: require('../assets/icons/campaigns.svg')
          },
          {
            key: 'AudioAds',
            route: vsprintf('/admin/%s/%s/audio-ads', [path, orgId]),
            title: Helper.getString('audio-ads'),
            icon: 'graphic_eq',
            image: require('../assets/icons/audio-ads.svg')
          },
          {
            key: 'UsersOfOrg',
            route: vsprintf('/admin/%s/%s/users', [path, orgId]),
            title: Helper.getString('admins'),
            icon: 'supervisor_account',
            image: require('../assets/icons/users.svg')
          },
          {
            key: 'Revenue',
            route: vsprintf('/admin/%s/%s/revenue', [path, orgId]),
            title: Helper.getString('revenue'),
            icon: 'monetization_on'
          }
        ]
      ]
    }
  }

  static getAdvertiserDrawerMenuItems(orgId) {
    const path = Controller.get().roleHelper().getPathByOrgType('ADVERTISER')
    if (this.isMobileview()) {
      return [
        [
          {
            key: 'DisplayAds',
            route: vsprintf('/admin/%s/%s/campaigns', [path, orgId]),
            title: Helper.getString('campaigns'),
            icon: 'connected_tv',
            image: require('../assets/icons/campaigns.svg')
          },
          {
            key: 'more',
            title: Helper.getString('menu'),
          }
        ]
      ]
    } else {
      return [
        [
          {
            key: 'DisplayAds',
            route: vsprintf('/admin/%s/%s/campaigns', [path, orgId]),
            title: Helper.getString('campaigns'),
            icon: 'connected_tv',
            image: require('../assets/icons/campaigns.svg')
          },
          {
            key: 'UsersOfOrg',
            route: vsprintf('/admin/%s/%s/users', [path, orgId]),
            title: Helper.getString('admins'),
            icon: 'supervisor_account',
            image: require('../assets/icons/users.svg')
          }
        ]
      ]
    }
  }

  static getPartnerDrawerMenuItems(orgId,org) {
    const path = Controller.get().roleHelper().getPathByOrgType('PARTNER')
    let sidebarMenu = []
    if (this.isMobileview()) {
      sidebarMenu = [
        {
          route: vsprintf('/admin/%s/%s', [path, orgId]),
          title: Helper.getString('dashboard'),
          icon: 'storefront',
          key: 'partnerDashboard',
          image: require('../assets/icons/dashboard.svg')
        },
        {
          key: 'AdPopReport',
          route: vsprintf('/admin/%s/%s/reports', [path, orgId]),
          title: Helper.getString('reportsPartner'),
          icon: 'loop',
          image: require('../assets/icons/reports.svg')
        },
        {
          route: vsprintf('/admin/%s/%s/screens', [path, orgId]),
          title: Helper.getString('venues'),
          icon: 'storefront',
          key: 'Venues',
          image: require('../assets/icons/venues.svg')
        },
        {
          key: 'more',
          title: Helper.getString('menu'),
        },
        {
          key: 'CampaignsDisplay',
          route: vsprintf('/admin/%s/%s/campaigns', [path, orgId]),
          title: Helper.getString('campaigns'),
          icon: 'connected_tv',
          image: require('../assets/icons/campaigns.svg')
        },
        {
          key: 'AssetsItems',
          route: vsprintf('/admin/%s/%s/assets', [path, orgId]),
          title: Helper.getString('media'),
          icon: 'perm_media',
          image: require('../assets/icons/media.svg')
        },
        // {
        //   key: 'LayoutsItems',
        //   route: vsprintf('/admin/%s/%s/layouts', [path, orgId]),
        //   title: Helper.getString('layouts'),
        //   icon: 'view_quilt',
        // },
        {
          key: 'UsersOfOrg',
          route: vsprintf('/admin/%s/%s/users', [path, orgId]),
          title: Helper.getString('users'),
          icon: 'supervisor_account',
          image: require('../assets/icons/users.svg')
        },
        {
          key: 'TagsDisplay',
          route: vsprintf('/admin/%s/%s/tags', [path, orgId]),
          title: Helper.getString('tags'),
          image: require('../assets/icons/tags.svg')
        },
        {
          key: 'MediaTagsDisplay',
          route: vsprintf('/admin/%s/%s/media-tags', [path, orgId]),
          title: Helper.getString('mediaTags'),
          icon: 'label',
          // image: require('../assets/icons/tags.svg')
        },
        {
          key: 'CustomFields',
          route: vsprintf('/admin/%s/%s/custom-fields', [path, orgId]),
          title: Helper.getString('customField'),
          icon: 'tune',
        },
        {
          key: 'AudioAds',
          route: vsprintf('/admin/%s/%s/audio-ads', [path, orgId]),
          title: Helper.getString('audio-ads'),
          image: require('../assets/icons/audio-ads.svg')
        },
      ]
    } else {
      sidebarMenu = [
        {
          route: vsprintf('/admin/%s/%s', [path, orgId]),
          title: Helper.getString('dashboard'),
          icon: 'storefront',
          key: 'partnerDashboard',
          image: require('../assets/icons/dashboard.svg')
        },
        {
          route: vsprintf('/admin/%s/%s/screens', [path, orgId]),
          title: Helper.getString('venues'),
          icon: 'storefront',
          key: 'Venues',
          image: require('../assets/icons/venues.svg')
        },
        {
          key: 'CampaignsDisplay',
          route: vsprintf('/admin/%s/%s/campaigns', [path, orgId]),
          title: Helper.getString('campaigns'),
          icon: 'connected_tv',
          image: require('../assets/icons/campaigns.svg')
        },
        {
          key: 'AssetsItems',
          route: vsprintf('/admin/%s/%s/assets', [path, orgId]),
          title: Helper.getString('media'),
          icon: 'perm_media',
          image: require('../assets/icons/media.svg')
        },
        // {
        //   key: 'LayoutsItems',
        //   route: vsprintf('/admin/%s/%s/layouts', [path, orgId]),
        //   title: Helper.getString('layouts'),
        //   icon: 'view_quilt',
        // },
        {
          key: 'AdPopReport',
          route: vsprintf('/admin/%s/%s/reports', [path, orgId]),
          title: Helper.getString('reportsPartner'),
          image: require('../assets/icons/reports.svg')
        },
        ...(AppHelper.hasFeature(org, 'AD_DEF_APPROVED') || AppHelper.hasFeature(org, 'AD_DEF_HOLD') ? [{
          key: 'ExchangeReports',
          route: vsprintf('/admin/%s/%s/exchange-reports', [path, orgId]),
          title: Helper.getString('exchangeReports'),
          image: require('../assets/icons/exchange-report.svg')
        }] : []),
        ...(AppHelper.hasFeature(org, 'AD_DEF_APPROVED') || AppHelper.hasFeature(org, 'AD_DEF_HOLD') ? [{
          key: 'CreativesMod',
          route: vsprintf('/admin/%s/%s/creatives', [path, orgId]),
          title: Helper.getString('creativesModeration'),
          image: require('../assets/icons/creatives-review.svg'),
        }] : []),
        {
          key: 'UsersOfOrg',
          route: vsprintf('/admin/%s/%s/users', [path, orgId]),
          title: Helper.getString('users'),
          icon: 'supervisor_account',
          image: require('../assets/icons/users.svg')
        },
        {
          key: 'TagsDisplay',
          route: vsprintf('/admin/%s/%s/tags', [path, orgId]),
          title: Helper.getString('tags'),
          image: require('../assets/icons/tags.svg')
        },
        {
          key: 'MediaTagsDisplay',
          route: vsprintf('/admin/%s/%s/media-tags', [path, orgId]),
          title: Helper.getString('mediaTags'),
          icon: 'label',
          // image: require('../assets/icons/tags.svg')
        },
        {
          key: 'CustomFields',
          route: vsprintf('/admin/%s/%s/custom-fields', [path, orgId]),
          title: Helper.getString('customField'),
          icon: 'tune',
        },
        {
          key: 'AudioAds',
          route: vsprintf('/admin/%s/%s/audio-ads', [path, orgId]),
          title: Helper.getString('audio-ads'),
          image: require('../assets/icons/audio-ads.svg')
        },
      ]
    }
    const filteredMenu = sidebarMenu.filter(menuItem => AppHelper.isAccessAllowed(menuItem.key));
    return [filteredMenu]
  }
  // This function is used, to show sidebar
  static isAccessAllowed = (pageKey, isSu = false) => {
    const userRoles = Controller.get().roleHelper().getUserRolesOfOrg()
    if (userRoles.includes('SUPERUSER') || userRoles.includes('VIEWER')) {
      return true;
    }
    let rolesPermissions = {}
    if (isSu) {
      rolesPermissions = {
        CAMPAIGNS: ['CampaignsDisplay', 'AssetsItems', 'CampaignsAudioBO', 'LayoutsItems', 'more'],
        ORGS: ['Orgs', 'more'],
        VENUES: ['Venues', 'VenueGroups', 'more'],
        REPORTS: ['AdPopReport', 'more']
      }
    } else {
      rolesPermissions = {
        VIEWER: ['partnerDashboard', 'Venues', 'CampaignsDisplay', 'AssetsItems', 'AdPopReport', 'TagsDisplay', 'CustomFields', 'AudioAds', 'more'],
        VENUES: ['partnerDashboard', 'Venues', 'TagsDisplay', 'AudioAds', 'CustomFields', 'more'],
        CAMPAIGNS: ['partnerDashboard', 'CampaignsDisplay', 'AssetsItems', 'more'],
        REPORTS: ['partnerDashboard', 'AdPopReport', 'more']
      }
    }
    // On SU Drill-down, all menu should show
    if (!isSu && Controller.get().userMgr().isInOrg('PRODUCT')) return true
    for (const role of userRoles) {
      if (rolesPermissions[role] && rolesPermissions[role].includes(pageKey)) {
        return true;
      }
    }
    return false;
  }

  static hasFeature(org, feature) {
    return org && org.features && org.features.includes(feature)
  }
  static getPaDrawerMenuItems(orgId) {
    const path = Controller.get().roleHelper().getPathByOrgType('PA')
    if (this.isMobileview()) {
      return [
        [{
          route: vsprintf('/admin/%s/%s/screens', [path, orgId]),
          title: Helper.getString('venues'),
          icon: 'storefront',
          key: 'Venues',
          image: require('../assets/icons/venues.svg')
        },
        {
          key: 'Revenue',
          route: vsprintf('/admin/%s/%s/revenue', [path, orgId]),
          title: Helper.getString('revenue'),
          icon: 'monetization_on',
          image: require('../assets/icons/reports.svg')
        },
        {
          key: 'UsersOfOrg',
          route: vsprintf('/admin/%s/%s/users', [path, orgId]),
          title: Helper.getString('admins'),
          icon: 'supervisor_account'
        },
        {
          key: 'more',
          title: Helper.getString('menu'),
        }]
      ]
    } else {
      return [
        [
          {
            route: vsprintf('/admin/%s/%s/screens', [path, orgId]),
            title: Helper.getString('venues'),
            icon: 'storefront',
            key: 'Venues'
          },
          {
            key: 'UsersOfOrg',
            route: vsprintf('/admin/%s/%s/users', [path, orgId]),
            title: Helper.getString('admins'),
            icon: 'supervisor_account'
          },
          {
            key: 'Revenue',
            route: vsprintf('/admin/%s/%s/revenue', [path, orgId]),
            title: Helper.getString('revenue'),
            icon: 'monetization_on'
          }
        ]
      ]
    }
  }

  static getFaDrawerMenuItems(orgId) {
    const path = Controller.get().roleHelper().getPathByOrgType('FA')
    if (this.isMobileview()) {
      return [
        [{
          route: vsprintf('/admin/%s/%s/screens', [path, orgId]),
          title: Helper.getString('venues'),
          icon: 'storefront',
          key: 'Venues',
          image: require('../assets/icons/venues.svg')
        },
        {
          key: 'Revenue',
          route: vsprintf('/admin/%s/%s/revenue', [path, orgId]),
          title: Helper.getString('revenue'),
          icon: 'monetization_on',
          image: require('../assets/icons/reports.svg')
        },
        {
          key: 'UsersOfOrg',
          route: vsprintf('/admin/%s/%s/users', [path, orgId]),
          title: Helper.getString('admins'),
          icon: 'supervisor_account'
        },
        {
          key: 'more',
          title: Helper.getString('menu'),
        }]
      ]
    } else {
      return [
        [
          {
            route: vsprintf('/admin/%s/%s/screens', [path, orgId]),
            title: Helper.getString('venues'),
            icon: 'storefront',
            key: 'Venues'
          },
          {
            key: 'UsersOfOrg',
            route: vsprintf('/admin/%s/%s/users', [path, orgId]),
            title: Helper.getString('admins'),
            icon: 'supervisor_account'
          },
          {
            key: 'Revenue',
            route: vsprintf('/admin/%s/%s/revenue', [path, orgId]),
            title: Helper.getString('revenue'),
            icon: 'monetization_on'
          }
        ]
      ]
    }
  }

  static isDrawerMenuEnabled(org) {
    let orgId = Controller.get().userMgr().getOrgId()
    const pName = window.location.pathname
    let menu = []
    if (pName.startsWith(`/admin/${Controller.get().roleHelper().getPathByOrgType('SITE')}/`)) {
      orgId = pName.split('/')[3]
      if (Controller.get().userMgr().isProductSU() || Controller.get().userMgr().isInOrg('PRODUCT')) {
        menu = AppHelper.getSiteUserDrawerMenuItems(orgId)
      } else if (AppConfig.ORGSU_ACCESS_ALLOWED && Controller.get().userMgr().hasOrgRole(orgId, 'SUPERUSER')) {
        Object.assign(menu, AppHelper.getSiteUserDrawerMenuItems(orgId));
        // const indexToDelete = menu[0].findIndex(currentValue => currentValue.key === 'UsersOfOrg')
        // if (indexToDelete >= 0) menu[0].splice(indexToDelete, 1)
      }
    } else if (pName.startsWith(`/admin/${Controller.get().roleHelper().getPathByOrgType('ADVERTISER')}/`)) {
      orgId = pName.split('/')[3]
      if (Controller.get().userMgr().isProductSU() || Controller.get().userMgr().isInOrg('PRODUCT')) {
        menu = AppHelper.getAdvertiserDrawerMenuItems(orgId)
      } else if (AppConfig.ORGSU_ACCESS_ALLOWED && Controller.get().userMgr().hasOrgRole(orgId, 'SUPERUSER')) {
        Object.assign(menu, AppHelper.getAdvertiserDrawerMenuItems(orgId));
        // const indexToDelete = menu[0].findIndex(currentValue => currentValue.key === 'UsersOfOrg')
        // if (indexToDelete >= 0) menu[0].splice(indexToDelete, 1)
      }
    } else if (pName.startsWith(`/admin/${Controller.get().roleHelper().getPathByOrgType('PARTNER')}/`)) {
      orgId = pName.split('/')[3]
      if (Controller.get().userMgr().isProductSU() || Controller.get().userMgr().isInOrg('PRODUCT')) {
        menu = AppHelper.getPartnerDrawerMenuItems(orgId, org)
      } else if (AppConfig.ORGSU_ACCESS_ALLOWED && Controller.get().userMgr().isInOrg(orgId)) {
        Object.assign(menu, AppHelper.getPartnerDrawerMenuItems(orgId, org));
        // const indexToDelete = menu[0].findIndex(currentValue => currentValue.key === 'UsersOfOrg')
        // if (indexToDelete >= 0) menu[0].splice(indexToDelete, 1)
      }
    } else if (pName.startsWith(`/admin/${Controller.get().roleHelper().getPathByOrgType('PA')}/`)) {
      orgId = pName.split('/')[3]
      if (Controller.get().userMgr().isProductSU() || Controller.get().userMgr().isInOrg('PRODUCT')) {
        menu = AppHelper.getPaDrawerMenuItems(orgId)
      } else if (AppConfig.ORGSU_ACCESS_ALLOWED && Controller.get().userMgr().hasOrgRole(orgId, 'SUPERUSER')) {
        Object.assign(menu, AppHelper.getPaDrawerMenuItems(orgId));
        // const indexToDelete = menu[0].findIndex(currentValue => currentValue.key === 'UsersOfOrg')
        // if (indexToDelete >= 0) menu[0].splice(indexToDelete, 1)
      }
    } else if (pName.startsWith(`/admin/${Controller.get().roleHelper().getPathByOrgType('FA')}/`)) {
      orgId = pName.split('/')[3]
      if (Controller.get().userMgr().isProductSU() || Controller.get().userMgr().isInOrg('PRODUCT')) {
        menu = AppHelper.getFaDrawerMenuItems(orgId)
      } else if (AppConfig.ORGSU_ACCESS_ALLOWED && Controller.get().userMgr().hasOrgRole(orgId, 'SUPERUSER')) {
        Object.assign(menu, AppHelper.getFaDrawerMenuItems(orgId));
        // const indexToDelete = menu[0].findIndex(currentValue => currentValue.key === 'UsersOfOrg')
        // if (indexToDelete >= 0) menu[0].splice(indexToDelete, 1)
      }
    } else if (pName.startsWith('/admin')) {
      if (Controller.get().userMgr().isProductSU() || Controller.get().userMgr().isInOrg('PRODUCT')) {
        const roles = Controller.get().roleHelper().getUserRolesOfOrg()
        menu = AppHelper.getAdminDrawerMenuItems(roles)
      }
    }
    if (AppConfig.ADMIN_DRAWER_MENU_ENABLED && menu.length > 0) {
      return menu
    }
    return null
  }

  static getPublicDrawerMenuItems() {
    return []
  }

  static formatTimestamp(utcTimestamp) {
    return moment.utc(utcTimestamp).local().format('Do MMM YYYY, h:mm a') + ' ' + moment().tz(moment.tz.guess()).format('z');
  }

  static customFormatTimestamp(utcTimestamp, format = 'Do MMM YYYY, h:mm a', displayZone = false) {
    return moment.utc(utcTimestamp).local().format(format) + (displayZone ? ' ' + moment().tz(moment.tz.guess()).format('z') : '')
  }

  static itemTitleImage(current) {
    let imageSouce
    if (current.image) {
      imageSouce = current.image
      if (AppHelper.isVideoContent(current.image)) {
        imageSouce = require('../assets/images/mp4.jpg')
      }
    }
    return (
      <div className={css(Styles.spanContainer)}>
        <div className={css(Styles.spanImgContainer)}>
          {current.image ?
            <img src={imageSouce} className={css(Styles.imageContent)} /> : ''}
        </div>
        <div className={css(Styles.spanTextContainer)}>
          <span className={css(Styles.itemValue)}>{current.title}</span>
          <span className={css(Styles.subItemValue)}>{AppHelper.formatTimestamp(current.modifiedTs)}</span>
        </div>
      </div>
    )
  }

  static isVideoContent(value) {
    if (value && value.toLowerCase().endsWith('.mp4')) {
      return true
    }
    return false
  }

  static formatActiveTime(milliseconds) {
    const prefix = 'Active: '
    if (milliseconds / Helper.MIN_MS < 10) return prefix + ' now'
    const moment = require('moment');

    const duration = moment.duration(milliseconds);

    if (duration.asDays() >= 1) {
      return `${prefix} ${Math.floor(duration.asDays())} day${duration.asDays() >= 2 ? 's' : ''} ago`;
    } else if (duration.asHours() >= 1) {
      return `${prefix} ${Math.floor(duration.asHours())} hour${duration.asHours() >= 2 ? 's' : ''} ago`;
    } else {
      return `${prefix} ${Math.floor(duration.asMinutes())} minute${duration.asMinutes() >= 2 ? 's' : ''} ago`;
    }
  }
  static getVenueStatusColor(milliseconds) {
    // milliseconds = Helper.currentTs()
    const moment = require('moment');
    const duration = moment.duration(milliseconds);
    if (duration.asDays() >= 1) {
      return '#FF5555' // Red
    } else if (duration.asMinutes() >= 10) {
      return '#FF9C55' // Orange
    } else {
      return '#3FD00F' // Green
    }
  }
  static getVenueStatusBackgroundColor(milliseconds) {
    // milliseconds = Helper.currentTs()
    const moment = require('moment');
    const duration = moment.duration(milliseconds);
    if (duration.asDays() >= 1) {
      return 'rgba(255, 85, 85, 0.1)' // Red
    } else if (duration.asMinutes() >= 10) {
      return 'rgba(255, 156, 85, 0.1)' // Orange
    } else {
      return 'rgba(63, 208, 15, 0.1)' // Green
    }
  }
  static getStatusBackgroundColorByKey(key) {
    key = key.toLowerCase()
    if (key === 'offline') {
      return 'rgba(255, 85, 85, 0.1)' // Red
    } else if (key === 'away') {
      return 'rgba(255, 156, 85, 0.1)' // Orange
    } else if (key === 'live' || key === 1) {
      return 'rgba(63, 208, 15, 0.1)' // Green
    } else if (key === 'enabled') {
      return 'rgba(63, 208, 15, 0.1)' // Green
    } else if (key === 'disabled') {
      return 'rgba(87, 87, 87, 0.1)'
    } else if (key === 'draft') {
      return 'rgba(199, 0, 199, 0.1)'
    } else {
      return 'rgba(87, 87, 87, 0.1)' // Green
    }
  }
  static getStatusColorByKey(key) {
    key = key.toLowerCase()
    if (key === 'offline') {
      return '#FF5555' // Red
    } else if (key === 'away') {
      return '#FF9C55' // Orange
    } else if (key === 'live' || key === 1) {
      return '#3FD00F' // Green
    } else if (key === 'enabled') {
      return '#3FD00F' // Green
    } else if (key === 'draft') {
      return 'rgba(176, 3, 176, 1)'
    } else if (key === 'disabled') {
      return 'rgba(87, 87, 87, 1)' // Green
    } else {
      return '#575757' // Green
    }
  }
  static getVenueStatusText(milliseconds) {
    const moment = require('moment');
    const duration = moment.duration(milliseconds);
    if (duration.asDays() >= 1) {
      return 'Offline' // Red
    } else if (duration.asMinutes() >= 10) {
      return 'Standby'  // Orange
    } else {
      return 'Online' // Green
    }
  }

  static processVenueItemsFromDa(items) {
    if (!items) return items
    items.forEach(i => {
      if (i.info) {
        let addr = ''
        if (i.info.title) addr = i.info.title
        if (i.info.address) addr = addr + ', ' + i.info.address
        i._ADDRESS = addr
      }
      for (const key in i) {
        if (key.startsWith('latestErr_')) {
          const ex = key.split('_')[1]
          try {
            i['latestStrErr_' + ex] = JSON.stringify(i['latestErr_' + ex])
          } catch(err) {
            i['latestStrErr_' + ex] = Helper.getString('malFormedError')
          }
        }
      }
    })
    return items
  }

  static processVenueItems(items) {
    if (!items) return items
    items.forEach(i => {
      if (i.info && i.info.width && i.info.height) {
        if (i.info.height > i.info.width) {
          i._ORIENTATION = 'PORTRAIT';
        } else {
          i._ORIENTATION = 'LANDSCAPE';
        }
      }
      if (i.info && i.info.address) {
        i._ADDRESS = i.info.address
      }
      if (i.siteInfo) {
        let addr = ''
        if(i.siteInfo.title)
          addr = i.siteInfo.title
        if(i.siteInfo.address)
          addr = addr + ', ' + i.siteInfo.address
        i._ADDRESS = addr
      }
      if (i.installationId) {
        i._REGISTRATION_STATUS = 'REGISTERED'
      } else {
        i._REGISTRATION_STATUS = 'NOTREGISTERED'
      }
      if (i.info && i.info.openoohcategory) {
        i._VENUETYPE = i.info.openoohcategory
      }
      if (i.latestDeviceFeed && i.latestDeviceFeed.currentTs) {
        i._ONLINE_STATUS = (AppHelper.getVenueStatusText(Helper.currentTs() - i.latestDeviceFeed.currentTs) || '').toUpperCase()
      }
      if (i.es && i.es.lat && i.es.lon) {
        i._LAT = i.es.lat
        i._LON = i.es.lon
      }
    })
    return items;
  }

  static campaignStateInfo() {
    return {
      ACTION_REQUIRED: {
        state: 'ACTION_REQUIRED',
        title: Helper.getString('paymentPending'),
        image: require('../assets/images/message-question.svg'),
        color: '#FE4F4F',
      },
      PENDING: {
        state: 'PENDING',
        title: Helper.getString('pendingApproval'),
        image: require('../assets/images/clock.svg'),
        color: '#FF8412'
      },
      LIVE: {
        state: 'LIVE',
        title: Helper.getString('enabled'),
        image: require('../assets/images/send-2.svg'),
        color: '#40B953'
      },
      DISABLED: {
        state: 'DISABLED',
        title: Helper.getString('disabled'),
        image: require('../assets/images/lock.svg'),
        color: '#747474'
      },
      ACTION_REQUIRED_DRAFT: {
        state: 'ACTION_REQUIRED',
        title: Helper.getString('draft'),
        image: require('../assets/images/message-question.svg'),
        color: '#FE4F4F',
      },
      CANCELLED: {
        state: 'CANCELLED',
        title: Helper.getString('cancelled'),
        image: require('../assets/images/message-question.svg'),
        color: '#FE4F4F',
      }
    }
  }

  static getAdvertiserCampaignState(item, org) {
    // reviewStatus - PENDING, APPROVED
    // subscriptionStatus - PENDING, ACTIVE
    // state - DRAFT, LIVE, DISABLED, CANCELLED
    const state = item.state
    const campaignStateInfo = AppHelper.campaignStateInfo()
    if (state === 'CANCELLED') {
      return campaignStateInfo.CANCELLED
    } else if ((item.subscriptionStatus !== 'ACTIVE' && org.reseller !== 'YES') ||
      (item.manualPaymentStatus !== 'PAID' && org.reseller === 'YES')
    ) {
      return campaignStateInfo.ACTION_REQUIRED
    } else if (item.reviewStatus === 'PENDING') {
      return campaignStateInfo.PENDING
    } else if (state === 'LIVE') {
      return campaignStateInfo.LIVE
    } else if (state === 'DISABLED') {
      return campaignStateInfo.DISABLED
    } else if (state === 'DRAFT') {
      return campaignStateInfo.ACTION_REQUIRED_DRAFT
    }
    return campaignStateInfo.ACTION_REQUIRED_DRAFT
  }

  static renderCampaignState(item, org) {
    const stateInfo = AppHelper.getAdvertiserCampaignState(item, org)
    return (
      <p className={css(Styles.subTitleStatus)} style={{ color: stateInfo.color }}><span>
        <img alt={Helper.getString('tileIcon')} className={css(Styles.tileIcon)} width={18} height={18}
          src={stateInfo.image} />
      </span>{stateInfo.title}
      </p>
    )
  }

  static formatCampaignTs(ts) {
    return moment(ts).format('MMM Do YYYY')
  }

  static renderCampaignCost(total, count, options) {
    if (!total) return ''
    if (options.org && options.org.reseller === 'YES') {
      if (options.manualPayment && options.manualPayment.amount) {
        return <p className={css(Styles.price)}>${Number(options.manualPayment.amount) / 100} for {count} Screen(s)</p>
      } else {
        return <p className={css(Styles.price)}>{count} Screen(s)</p>
      }
    }
    let msg = `$${total ? total / 100 : 0} per month`
    if (count) {
      msg += ` for ${count} screen(s)`
    }
    return <p className={css(Styles.price)}>{msg}</p>
  }

  static formatDuration(durationMs) {
    if (durationMs <= this.DAY_MS) {
      return moment.utc(durationMs).format('HH:mm:ss') // handles only 24 hrs
      // return moment.utc(durationMs).format('HH:mm') // handles only 24 hrs
    } else {
      const dur = moment.duration(durationMs)
      const hours = Math.floor(dur.asHours())
      const mins = Math.floor(dur.asMinutes()) - hours * 60
      const sec = Math.floor(dur.asSeconds()) - hours * 60 * 60 - mins * 60
      //return hours + ':' + mins + ':' + ((sec > 9) ? sec : ('0' + sec))
      return hours + ':' + ((mins > 9) ? mins : ('0' + mins))
    }
  }
  static bytesToGigabytes(bytes) {
    return Number(bytes / Math.pow(1024, 3)).toFixed(2);
  }
  static calculatePercentage(part, whole, percentageSign = '') {
    return Math.floor((part / whole) * 100) + percentageSign;
  }

  static processAdsForVenuePlayer(inputAds, orgType = '') {
    if (!inputAds) return []
    const allAdsInOrder = []
    let adsContainer = [
      // 'displayAdsOthers',
      'displayCampaignsBo',
      'displayCampaignsStore',
      'displayCampaignsAdvertiser'
    ]
    if (orgType === 'PARTNER') {
      adsContainer = [
        'displayCampaignsBo',
      ]
    }
    if (inputAds) {
      adsContainer.map(eachCamp => {
        // console.log('StartPlay: ADS',inputAds, eachCamp)
        if (inputAds[eachCamp] && inputAds[eachCamp].length > 0) {
          inputAds[eachCamp].map((eachCampaign) => {
            if (eachCampaign.ads && eachCampaign.ads.length > 0) {
              if (orgType === 'PARTNER' && eachCampaign.campaignId.includes('PRODUCT-')) return
              const campaignTiming = eachCampaign.timing ? eachCampaign.timing : {}
              const allCampaignAds = eachCampaign.ads.filter(x => x.mediaType === 'VIDEO' || x.mediaType === 'IMAGE' || x.mediaType === 'WEBLINK').map(x => x = { ...x, campaignTiming: campaignTiming })
              allAdsInOrder.push(...allCampaignAds)
            }
          })
        }
      })
    }
    return allAdsInOrder
  }

  static padNumberWithZeros(number) {
    // let str = number.toString();
    // while (str.length < 3) {
    //   str = '0' + str;
    // }
    // return str;
    return number;
  }

  static THOUSAND = 1000
  static MILLION = 1000000

  static abbrNum(number) {
    if (number >= this.MILLION) {
      return (number / this.MILLION).toFixed(1) + 'M'
    } else if (number >= this.THOUSAND) {
      return Math.round(number / this.THOUSAND) + 'K'
    }
    return String(Math.round(number))
  }

  static getVenueStatus = (venueFeedTime) => {
    return (
      <Tooltip title={AppHelper.formatActiveTime(venueFeedTime)} arrow>
        <div className={css(Styles.statusTag)} style={{ backgroundColor: AppHelper.getVenueStatusBackgroundColor(venueFeedTime) }}>
          <span className={css(Styles.circleFill)} style={{ backgroundColor: AppHelper.getVenueStatusColor(venueFeedTime) }}></span>
          <span className={css(Styles.statusText)}>
            {AppHelper.getVenueStatusText(venueFeedTime)}
          </span>
        </div>
      </Tooltip>
    )
  }

  static offlineStatus = () => {
    return (
      <div className={css(Styles.statusTag)} style={{ backgroundColor: AppHelper.getVenueStatusBackgroundColor(Helper.currentTs()) }}>
        <span className={css(Styles.circleFill)} style={{ backgroundColor: AppHelper.getVenueStatusColor(Helper.currentTs()) }}></span>
        <span className={css(Styles.statusText)}>
          {AppHelper.getVenueStatusText(Helper.currentTs())}
        </span>
      </div>
    )
  }

  static redChip = (value) => {
    return (
      <div className={css(Styles.redTag)} style={{ backgroundColor: 'rgba(255, 85, 85, 0.1)' }}>
        <span className={css(Styles.redTagText)}>
          {value}
        </span>
      </div>
    )
  }

  static getMaxVideoDuration(options, org) {
    const maxVideoDuration = 90;
    // if (options && options.pageForOrgType === 'PARTNER') {
    //   if (org && AppHelper.hasFeature(org, 'LARGEVIDEO')) {
    //     maxVideoDuration = 90
    //   } else {
    //     maxVideoDuration = 45
    //   }
    // }
    return maxVideoDuration // seconds
  }

  static getMaxVideoFileSize(options, org) {
    let maxFileSize = 50000000;
    if (options && options.pageForOrgType === 'PARTNER') {
      if (org && AppHelper.hasFeature(org, 'LARGEVIDEO')) {
        maxFileSize = 100000000
      }
    }
    return maxFileSize // seconds
  }

  static addScheduleFieldsToAssetsFormField(assetsFormAddition, formDefinition) {
    // Push New dateTimeStr Fields
    if (assetsFormAddition &&
      formDefinition &&
      formDefinition.steps &&
      formDefinition.steps[0] &&
      formDefinition.steps[0].fields) {
      // formDefinition.steps[0].fields.push(...assetsFormAddition)
      if (formDefinition.steps[0].fields.length > 0) {
        formDefinition.steps[0].fields.splice(formDefinition.steps[0].fields.length - 1, 0, ...assetsFormAddition);
        formDefinition.steps[0].fields[formDefinition.steps[0].fields.length - 1].placement = 'left'
        formDefinition.steps[0].fields[formDefinition.steps[0].fields.length - 4].placement = 'right'
      } else {
        formDefinition.steps[0].fields.push(...assetsFormAddition);
      }
      console.log('thisFields', formDefinition.steps[0].fields)
    }
  }


  static isMobileview() {
    const width = window.innerWidth
    return width < 1024
  }

  static fullWidthCondition() {
    if (window.innerWidth && window.innerWidth < 1024) {
      return true
    }
    return false
  }

  static processSubtasks = (options) => {
    const { task } = options
    const imgSubTasks = []
    const nonImgSubTasks = []
    if (!task || !task.subtasks) return []
    for (const i in task.subtasks) {
      if (!task.subtasks[i].values || task.subtasks[i].values.length === 0) continue
      if (task.subtasks[i].iType === 'IMAGES') {
        imgSubTasks.push(task.subtasks[i])
      } else {
        nonImgSubTasks.push(task.subtasks[i])
      }
    }
    return { imgSubTasks, nonImgSubTasks }
  }

  static isNonApkDevice(deviceInfo) {
    if (deviceInfo && deviceInfo.deviceType && (deviceInfo.deviceType === 'API' || deviceInfo.deviceType === 'WC')) return true
    return false
  }

  static attachVideoValidationLabel({ formDefinition, maxWidthOrHeight, maxVideoDuration, fileSizeLimit }) {
    formDefinition.steps[0].fields.find((field) => {
      if (field.condition &&
        field.condition.key === 'iType' &&
        field.condition.value === 'VIDEO') {
        field.label = <span className={css(Styles.videoLabel)}>
          {field.label}
          <small className={css(Styles.videoLabelValidation)}>
            (Max Width/Height: {maxWidthOrHeight}, Duration: {maxVideoDuration}s, File Size: {fileSizeLimit / 1000000}Mb)
          </small>
        </span>;
      }
    })
  }

  static covertCentsToDollar = (amount) => {
    if (!amount) return '$ 0'
    return '$ ' + (Number(amount) / 100)
  }

  static getHdmiInfo = (current) => {
    if (current && current.latestDeviceFeed && current.latestDeviceFeed.HDMIState) {
      if (current.latestDeviceFeed.HDMIState === 'YES') {
        return (
          <Tooltip title={Helper.getString('hdmi_connected')}>
            {AppUiHelper.chipLive(Helper.getString('hdmi'), true)}
          </Tooltip>
        )
      } else if (current.latestDeviceFeed.HDMIState === 'NO') {
        return (
          <Tooltip title={Helper.getString('hdmi_not_connected')}>
            {AppUiHelper.chipError(Helper.getString('hdmi'))}
          </Tooltip>
        )
      }
    }
  }

  static getTagChips = (currentTagIds, tags) => {
    if (!tags || !tags.items || tags.items.length === 0) return []
    const filteredItems = tags.items.filter(x => currentTagIds.includes(x.id)).map(x => x.title)
    return filteredItems || []
  }

  static getFileType = (file) => {
    /* eslint-disable */
    switch (file.type) {
      case 'image/png':
        return 'IMAGE'
      case 'image/jpeg':
        return 'IMAGE'
      case 'image/jpg':
        return 'IMAGE'
      case 'video/mp4':
        return 'VIDEO'
      default:
        return 'FILE'
    }
    /* eslint-enable */
  }

  static buildPayload(fields, current) {
    const result = {}
    Object.assign(result)

    fields.forEach(field => {
      const key = field.key
      let value = current[key]
      if (value === undefined && field.defaultValue !== undefined) value = field.defaultValue
      if (value === undefined) value = ''
      result[key] = value
    })
    return result
  }

  static getBaseFileName(fileName) {
    return fileName.substring(0, fileName.lastIndexOf('.'))
  }

  static getSyncInfo = (current) => {
    if (current && current.latestDeviceFeed && current.latestDeviceFeed.versionCode && current.latestDeviceFeed.versionCode >= 147) {
      if (current && current.deviceOutOfSync) {
        if (current.deviceOutOfSync === 'YES') {
          const outOfSyncMessage = Helper.getString('ouOfSyncMessage')
          let showPercentageMessage = ''
          //Syncing 1% | 1 Mbps / 1 Kbps
          if (current && current.syncPercent) {
            showPercentageMessage += ' Syncing ' + current.syncPercent + '% '
          }
          if (current && current.syncBandwidth) {
            showPercentageMessage += '| ' + AppHelper.formatBytesToMbpsOrKbps(current.syncBandwidth)
          }
          return (
            <Tooltip classes={{ tooltip: css(Styles.customTooltip) }} title={showPercentageMessage ? showPercentageMessage : outOfSyncMessage}>
              {
                showPercentageMessage
                  ? AppUiHelper.chipOutOfSync('Syncing ' + current.syncPercent + '%')
                  : AppUiHelper.chipOutOfSync(outOfSyncMessage)
              }
            </Tooltip>
          )
        } else if (current.deviceOutOfSync === 'NO') {
          return (
            <Tooltip classes={{ tooltip: css(Styles.customTooltip) }} title={Helper.getString('inSyncMessageTooltip')}>
              {AppUiHelper.chipInSync(Helper.getString('inSyncMessage'))}
            </Tooltip>
          )
        }
      }
    }
  }

  static formatBytesToMbpsOrKbps = (bytes, decimalPlaces = 2) => {
    // Convert bytes to bits
    const bits = bytes * 8;
    // Check if the size is less than 1 Megabit
    if (bits < 1000 * 1000) {
      const kilobits = bits / 1000; // 1 Kb = 1000 bits
      return `${kilobits.toFixed(decimalPlaces)} Kbps`; // Kilobits per second
    } else {
      // Convert bits to Megabits
      const megabits = bits / (1000 * 1000); // 1 Mb = 1,000,000 bits
      return `${megabits.toFixed(decimalPlaces)} Mbps`; // Megabits per second
    }
  }


  static formatNumberStats(num) {
    return new Intl.NumberFormat('en-US').format(num || 0);
  }

  static isOohConsoleHost() {
    const hostname = window.location.hostname;
    if(hostname.endsWith('oohconsole.com')) return true
    return false
  }

  static parseOrgId(pathname) {
    if(pathname) {
      const pathSpilt = pathname.split('/')
      // console.log(pathSpilt,'PATH_SPLIT');
      const orgRouteTypes = ['orgs', 'sites', 'advertisers', 'partners', 'pas', 'fas']
      if(pathname && pathname.length > 2 && pathSpilt[1] === 'admin' && orgRouteTypes.includes(pathSpilt[2])) {
        return pathSpilt[3]
      }
    }
  }

  static getOrgType({ groupId }) {
    const groupIdToTitle = {
      PA: 'PA REVENUE',
      PARTNER: 'CMS',
      FA: 'FA REVENUE',
      SITE: 'STORE'
    }
    let title = ''
    if(groupIdToTitle[groupId]) title = groupIdToTitle[groupId]
    return title
  }

  static getAlertTitle (type) {
    const alertMap = {
      CONNECTIVITYALERT: 'Connectivity Alert'
    }
    return alertMap[type] || type
  }

}

const Styles = StyleSheet.create({
  spanContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  spanTextContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  spanImgContainer: {
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12
  },
  imageContent: {
    height: '100%',
    width: '100%',
    borderRadius: 6,
    objectFit: 'cover'
  },
  itemValue: {
    fontSize: 16,
  },
  subItemValue: {
    fontSize: 12,
  },
  subTitleStatus: {
    fontSize: 14,
    lineHeight: '19px',
    margin: 0,
    flex: 1,
    textAlign: 'left',
    display: 'flex',
  },
  tileIcon: {
    width: 18,
    height: 18,
    marginRight: 10
  },
  subLabel: {
    fontSize: 16,
    fontWeight: 400,
    color: '#747474',
    margin: 0,
    marginRight: 8
  },
  price: {
    fontSize: 24,
    fontWeight: 600,
    color: '#1B1B1B',
    margin: 0
  },
  statusText: {
    color: 'rgba(87, 87, 87, 1)',
    fontSize: 14,
    paddingLeft: 2
  },
  statusTag: {
    display: 'flex',
    alignItems: 'center',
    padding: '7px 16px',
    justifyContent: 'center',
    borderRadius: '6px',
    maxWidth: 'max-content'
  },
  circleFill: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    marginRight: 4
  },
  videoLabel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  videoLabelValidation: {
    color: 'tomato'
  },
  redTag: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px',
    justifyContent: 'center',
    borderRadius: '6px',
    width: '70px',
  },
  redTagText: {
    color: 'rgba(87, 87, 87, 1)',
    fontSize: 12,
  }
})



// WEBPACK FOOTER //
// ./src/helpers/AppHelper.js